import { render, staticRenderFns } from "./deleteCommunity.vue?vue&type=template&id=7c4b6a74&scoped=true"
import script from "./deleteCommunity.vue?vue&type=script&lang=js"
export * from "./deleteCommunity.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunity.vue?vue&type=style&index=0&id=7c4b6a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b6a74",
  null
  
)

export default component.exports